import React from 'react'

import RichTextAndImageCard from '../../src/components/RichTextAndImageCard'
import { FullWidthRichTextCardSlice } from '../../prismicio-types'

const RichTextCardSlice = ({ slice }: { slice: FullWidthRichTextCardSlice }) => {
	return (
		<RichTextAndImageCard
			content={slice.primary.content}
			background_color={slice.primary.background_color}
			display_image={slice.primary.display_image}
			image={slice.primary.image}
		/>
	)
}

export default RichTextCardSlice
